import { useState } from 'react'
import { Outlet } from 'react-router-dom'
import LeftSidebar from './LeftSidebar'
import { TopNavbar } from './ui/top-navbar'
import { cn } from '@/lib/utils'
import { Footerdemo } from './ui/footer-section'
import { TimezoneDetectionManager } from './timezone/TimezoneDetectionManager'
import { PageTransition } from './transitions/PageTransition'

export default function Layout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)

  return (
    <div className="flex min-h-screen bg-background">
      {/* Mobile Overlay - Render before sidebar for proper z-index stacking */}
      <div
        className={cn(
          'fixed inset-0 bg-black/50 z-40 md:hidden',
          'transition-opacity duration-300',
          isSidebarOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
        onClick={() => setIsSidebarOpen(false)}
      />

      {/* Sidebar */}
      <div className={cn(
        'fixed md:sticky top-0 left-0 h-screen w-64 flex-shrink-0',
        'transform transition-transform duration-300 ease-in-out z-50',
        isSidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'
      )}>
        <LeftSidebar className="h-full" />
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopNavbar
          className="sticky top-0 z-40"
          onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)}
        />
        <main className="flex-1">
          <PageTransition className="w-full h-full">
            <Outlet />
          </PageTransition>
        </main>
        {/* Footer - hidden automatically when user is authenticated */}
        <Footerdemo />
      </div>

      {/* Timezone Detection Manager - shows notifications for timezone auto-detection */}
      <TimezoneDetectionManager
        showToast={true}
        showCustomNotification={true}
        autoTrigger={true}
      />
    </div>
  )
}
